import {onError} from '@apollo/client/link/error';
import Sentry from '../lib/Sentry';

const GRAPHQL_ERROR_CATEGORY = 'GraphQL Error';
const GRAPHQL_ERROR_DEFAULT_MESSAGE = 'Unknown GraphQL error';
const NETWORK_ERROR_CATEGORY = 'Network Error';
const NETWORK_ERROR_DEFAULT_MESSAGE = 'Unknown network error';

const handleNetworkError = ({networkError}) => {
  if (networkError) {
    Sentry.addBreadcrumb({
      category: NETWORK_ERROR_CATEGORY,
      message: networkError.message || NETWORK_ERROR_DEFAULT_MESSAGE,
      level: 'info',
      data: {networkError},
    });
  }
};

const formatGraphQLErrorData = ({errors, operation}) => ({
  errors,
  query:
    operation &&
    operation.query &&
    operation.query.loc &&
    operation.query.loc.source &&
    operation.query.loc.source.body,
  variables: operation && operation.variables,
});

const handleGraphQLError = ({operation, response}) => {
  const errors =
    response && response.errors ? response.errors.filter(err => !err.skipReporting) : [];

  if (errors.length === 0) return;

  Sentry.addBreadcrumb({
    category: GRAPHQL_ERROR_CATEGORY,
    message: errors
      .map(err => err.message || GRAPHQL_ERROR_DEFAULT_MESSAGE)
      .filter(msg => !!msg)
      .join('; '),
    level: 'info',
    data: formatGraphQLErrorData({errors, operation}),
  });
};

export default () =>
  onError(({networkError, operation, response} = {}) => {
    try {
      handleGraphQLError({operation, response});
      handleNetworkError({networkError});
    } catch (error) {
      Sentry.captureException(error);
    }
  });
